import { RoomConfiguration as GraphQLRoomConfiguration } from 'generated/graphql';
import { RoomConfiguration as ReduxRoomConfiguration } from 'store/groupDetailsSlice';

import RoomConfigurationDisplay from './RoomConfigurationDisplay';

// Union type to handle both GraphQL and Redux types
type CompatibleRoomConfiguration =
  | GraphQLRoomConfiguration
  | ReduxRoomConfiguration;

interface RoomDetailsSectionProps {
  roomType: 'single' | 'double' | 'suite';
  roomTypeLabel: string;
  configurations?: CompatibleRoomConfiguration[];
  quantity: number;
}

const RoomDetailsSection = ({
  roomType,
  roomTypeLabel,
  configurations,
  quantity,
}: RoomDetailsSectionProps) => {
  return (
    <div>
      <p className="mb-2 text-sm font-medium text-gray-500">{roomTypeLabel}</p>
      {configurations ? (
        <RoomConfigurationDisplay
          configurations={configurations}
          roomType={roomType}
        />
      ) : (
        <p className="font-arimo text-base font-medium text-gray-900">
          {quantity}
        </p>
      )}
    </div>
  );
};

export default RoomDetailsSection;
